module.exports = __webpack_public_path__ + "img/IMG_2552-2.10aa45ba.jpg";